enum ActionTypes {
  LANGUAGE_KEY = 'language',
  CHANGE_LOCALE = 'language/CHANGE_LOCALE',
}

export default ActionTypes;
